
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10.642","height":"12.206"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Component_114_22","data-name":"Component 114 – 22","transform":"translate(.51 .5)"}},[_c('g',{attrs:{"id":"Group_26385","data-name":"Group 26385"}},[_c('g',{attrs:{"id":"Group_26391","data-name":"Group 26391"}},[_c('g',{attrs:{"id":"Group_26392","data-name":"Group 26392"}},[_c('path',{attrs:{"id":"Path_20459","data-name":"Path 20459","d":"M1.791 3.065H7.83a2.056 2.056 0 011.782 2.246V8.96a2.054 2.054 0 01-1.782 2.246H1.791A2.055 2.055 0 01.011 8.96V5.311a2.056 2.056 0 011.78-2.246z","fill":"none","stroke":"#5a677d","stroke-width":"1"}}),_c('path',{attrs:{"id":"Path_20460","data-name":"Path 20460","d":"M2.573 3.002s-.164-3 2.252-3 2.31 3 2.31 3","fill":"none","stroke":"#5a677d","stroke-width":"1"}}),_c('path',{attrs:{"id":"Path_20461","data-name":"Path 20461","d":"M31.428 10.359a1.212 1.212 0 10-1.753 1.07v1.177a.381.381 0 00.379.379h.321a.381.381 0 00.379-.379v-1.177a1.2 1.2 0 00.674-1.07","transform":"translate(-25.376 -3.53)","fill":"#5a677d"}})])])])])])
          )
        }
      }
    